<template>
  <div
    class="alert_bg"
    v-if="alertMsg.visible && route.path.includes('kibot/bot')"
  >
    <div class="alert-wrapper" :style="{ top: alertTopClass }">
      <h5
        :class="errorCode == 'deleteBot' ? 'delete' : ''"
        v-html="messageHtml"
      ></h5>
      <div v-html="contentHtml"></div>
      <div style="display: flex; gap: 1rem">
        <!-- 조건에 따라 버튼 HTML을 동적으로 렌더링 -->
        <button
          class="btn-linear"
          :class="[
            { pink: button.type == 'pink' },
            { long: button.type == 'long' },
          ]"
          @click="handleButtonClick(button.action)"
          v-for="button in buttons"
          :key="button.label"
          v-html="button.label"
        ></button>
      </div>
    </div>
  </div>
  <div class="alert-wrapper" :style="{ top: alertTopClass }" v-else>
    <h5 :class="locale == 'ja' || locale == 'zh' || locale == 'vi' ? 'font__highlight__vi' : 'font__highlight'" v-html="messageHtml"></h5>
    <div v-html="contentHtml"></div>
    <div style="display: flex; gap: 1rem">
      <!-- 조건에 따라 버튼 HTML을 동적으로 렌더링 -->
      <button
        class="btn-linear"
        @click="handleButtonClick(button.action)"
        v-for="button in buttons"
        :key="button.label"
        v-html="button.label"
      ></button>
    </div>
  </div>
  <!-- <div class="bg-blur"></div> -->
</template>

<script setup>
import warnIcon from "@/assets/images/icons/warn-icon.png";
import { computed, defineEmits, nextTick, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from 'vue-i18n'
const route = useRoute();
const router = useRouter();
const emit = defineEmits([
  "stopConfirm",
  "terminateConfirm",
  "showSettingModal",
  "reloadData",
  "stopBot",
  "deletBot",
  "successSet",
]);
const store = useStore();
const alertMsg = computed(() => store.state.usePopupList.alertMsg);

const errorCode = computed(() => alertMsg.value.code);
let userInfo = computed(() => store.state.userInfo.risingUserInfo);

const alertTopClass = ref("50%"); // 기본값 설정
const baseUrl = process.env.VUE_APP_HOME_URL

const { t, locale } = useI18n({ useScope: 'global' })

watchEffect(() => {
  if (
    Object.keys(userInfo.value).length !== 0 &&
    userInfo.value.chart_subsc_wht === "Y"
  ) {
    alertTopClass.value =
      route.path === "/kibot/chart" || route.path === "/kibot/chart2"
        ? "20%"
        : "50%";
  } else {
    if (
      window.innerWidth > 1024 &&
      (route.path === "/kibot/chart" || route.path === "/kibot/chart2")
    ) {
      nextTick(() => {
        window.scrollTo(0, 0);
        // const listWrapper = document.querySelector('.kibot-chart__list-wrapper');
        alertTopClass.value = "300px";
        // alertTopClass.value = (listWrapper && listWrapper.clientHeight > 300) ? '300px' : '300px';
      });
    } else {
      alertTopClass.value = "50%";
    }
  }
});

const closeAlert = () => {
  // console.log('error Code', errorCode.value);
  store.commit("usePopupList/toggleAlertMsg", { visible: false });
};

// 버튼 클릭 핸들러
const handleButtonClick = (action) => {
  // console.log("actionactionaction", action);
  if (action === "close") {
    if (errorCode.value == 422 || errorCode.value == 4) {
    location.href = `${baseUrl}/autobot/position?menuName=position_bot`;
      location.href = `${baseUrl}/login`;
    } else if (errorCode.value == "chartPurmission") {
      location.href = `${baseUrl}/price/chart`;
    }
    closeAlert();
    // console.log('errorCode',errorCode.value);
  } else if (action === "purchase") {
    location.href = `${baseUrl}/price/kibot_auto`;
    closeAlert();
  } else if (action === "stop") {
    emit("stopConfirm", true);
    closeAlert();
  } else if (action === "terminate" || action === "terminateGrid") {
    emit("terminateConfirm", true);
    closeAlert();
  } else if (action === "confirm") {
    if (errorCode.value == "notSetting") {
      emit("showSettingModal", true);
    }
  } else if (action == "deleteBot") {
    emit("deletBot", true);
  } else if (action == "stopBotPrev") {
    emit("stopBot", true);
  } else if (action == "stateBot" || action == "noRef") {
    location.href = `${baseUrl}/autobot/position?menuName=position_bot`;
  } else if (action == "registerSuccess") {
    emit("successSet");
  } else if (action == "gridStop") {
    router.push("/kibot/bot/position");
  } else if (action == "positionStop") {
    router.push("/kibot/bot/position");
  } else if (
    action == "botStop" ||
    action == "botStart" ||
    action == "botSet" ||
    action == "botDelete"
  ) {
    emit("reloadData", true);
  }
};

// 동적으로 변경되는 메시지 HTML
const messageHtml = computed(() => {
  switch (errorCode.value) {
    case 1:
      return t('alert.unknownError');
    case 2:
      return t('alert.loginFailed');
    case 3:
      return t('alert.APIError');
    case 4:
      return t('alert.userNotFound');
    case 5:
      return t('alert.walletError');
    case 6:
      return t('alert.unRegisterEx');
    case 7:
      return t('alert.P&LRange');
    case 8:
      return t('alert.leverageError');
    case 9:
      return t('alert.invalidPlan');
    case 10:
      return t('alert.userRegistered');
    case 11:
      return t('alert.unregisteredUser');
    case 12:
      return t('alert.InvalidNumber');
    case 13:
      return t('alert.needStop');
    case 422:
      return t('alert.loginRequired');
    case 14:
      return t('alert.needStop');
    case 15:
      return t('alert.unRegisteredKey');
    case 17:
      return t('alert.duplicatedSymbol');
    case 18:
      return t('alert.duplicatePosition');
    case "Invalid":
      return t('alert.uidMismatch');
    case "coinNum":
      return t('alert.limit3');
    case "purchase":
      return t('alert.purchaseBot');
    case "expired":
      return t('alert.expiredBot');
    case "terminate":
      return t('alert.cancelBot');
    case "terminateGrid":
      return t('alert.terminateGrid');
    case "impossibleTerminante":
      return t('alert.disableTerminate');
    case "stop":
      return t('alert.stopTrading');
    case "caution":
      return t('alert.needStopForSetting');
    case "stopAble":
      return t('alert.stopAble');
    case "success":
      return t('alert.success');
    case "registerSuccess":
      return t('alert.registerSuccess');
    case "registerSuccessGrid":
      return t('alert.registerSuccessGrid');
    case "apiDelSuccess":
      return t('alert.apiDelSuccess');
    case "botDelete":
      return t('alert.botDelete');
    case "botStop":
      return t('alert.botStop');
    case "botStart":
      return t('alert.botStart');
    case "botSet":
      return t('alert.botSet');
    case "fillAll":
      return t('alert.fillAll');
    case "numberOnly":
      return t('alert.requiredLeverage');
    case "wrongLeverage":
      return t('alert.numberOnly');
    case "wrongProfit":
      return t('alert.invalidTakeProfit');
    case "wrongLoss":
      return t('alert.invalidStopLoss');
    case "checkCaution":
      return t('alert.needCheck');
    case "copy":
      return t('alert.copy');
    case "notSetting":
      return t('alert.needSetting');
    case "notReady":
      return t('alert.comingSoon');
    case "chartPurmission":
      return t('alert.needPermission');
    case "noRef":
      return t('alert.noRef');
    case "stateBot":
      return t('alert.stateBot');
    case "deleteBot":
      return t('alert.deleteBot');
    case "stopBotPrev":
      return t('alert.stopBotPrev');
    case "stopGrid":
      return t('alert.stopGrid');
    case "stopPosition":
      return t('alert.stopPosition');
    default:
      return t('alert.unknownError');
  }
});

// 동적으로 변경되는 콘텐츠 HTML
const contentHtml = computed(() => {
  if (errorCode.value === "expired") {
    return `<p>${t('alert.expired')}</p>`;
  } else if (
    errorCode.value === "terminateGrid" ||
    errorCode.value === "terminate" ||
    errorCode.value === "stop"
  ) {
    return `<p>${t('alert.stopTransaction')}</p><div class="alert-container"><img src="${warnIcon}"/><span>${t('alert.causeLoss')}</span></div>`;
  } else if (errorCode.value == 11) {
    return `<p>${t('alert.needPermission')}</p>`;
  } else if (errorCode.value == "deleteBot") {
    return `<p>${t('alert.delGridSetting')}</p>`;
  } else if (errorCode.value == "stopBotPrev") {
    return `<p>${t('alert.stopGridSymbol')}</p>`;
  } else {
    return "";
  }
});

// 조건에 따른 버튼 목록
const buttons = computed(() => {
  switch (errorCode.value) {
    // case '11':
    // case '422':
    //     return [
    //         { label: 'Login', action: 'login' },
    //         { label: 'Close', action: 'close' }
    //     ];
    case "expired":
      return [
        // { label: 'Close', action: 'close' },
        { label: t('alert.purchase'), action: "purchase" },
      ];
    case "purchase":
      return [
        // { label: 'Close', action: 'close' },
        { label: t('alert.purchase'), action: "purchase" },
      ];
    case 11:
      return [
        // { label: 'Close', action: 'close' },
        { label: t('alert.purchase'), action: "purchase" },
      ];
    case "terminate":
      return [
        { label: t('alert.no'), action: "close" },
        { label: t('alert.yes'), action: "terminate" },
      ];
    case "terminateGrid":
      return [
        { label: t('alert.no'), action: "close" },
        { label: t('alert.yes'), action: "terminate" },
      ];
    case "stop":
      return [
        { label: t('alert.no'), action: "close" },
        { label: t('alert.yes'), action: "stop" },
      ];
    case "deleteBot":
      return [
        { label: t('alert.close'), action: "close" },
        { label: t('alert.delete'), action: "deleteBot", type: "pink" },
      ];
    case "stopBotPrev":
      return [
        { label: t('alert.close'), action: "close" },
        { label: t('alert.stop'), action: "stopBotPrev", type: "pink" },
      ];
    case "botStop":
      return [{ label: t('alert.confirm'), action: "botStop" }];
    case "botStart":
      return [{ label: t('alert.confirm'), action: "botStart" }];
    case "botSet":
      return [{ label: t('alert.confirm'), action: "botSet" }];
    case "botDelete":
      return [{ label: t('alert.confirm'), action: "botDelete" }];
    case "stateBot":
      return [
        { label: t('alert.applyBot'), action: "stateBot", type: "long" },
      ];
    case "noRef":
      return [{ label: t('alert.confirm'), action: "noRef" }];
    case "registerSuccess":
      return [{ label: t('alert.confirm'), action: "registerSuccess" }];
    case "stopGrid":
      return [
        { label: t('alert.close'), action: "close" },
        { label: t('alert.stopGridBot'), action: "gridStop", type: "long" },
      ];
    case "stopPosition":
      return [
        { label: t('alert.close'), action: "close" },
        { label: t('alert.stopPositionBot'), action: "positionStop", type: "long" },
      ];
    default:
      return [{ label: t('alert.confirm'), action: "close" }];
  }
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/commons/modal/modal.scss";
.alert_bg {
  position: fixed; /* 화면에 고정 */
  top: 0;
  left: 0;
  width: 100vw; /* 화면 전체 너비 */
  height: 100vh; /* 화면 전체 높이 */
  background-color: rgba(0, 0, 0, 0.5); /* 검정색 배경, 50% 투명도 */
  display: flex;
  justify-content: center; /* 가로 중앙 정렬 */
  align-items: center; /* 세로 중앙 정렬 */
  z-index: 999;
}

.alert-wrapper {
  padding: 30px;
  box-sizing: border-box;

  &.visible {
    display: flex !important;
  }

  h5 {
    &.delete {
      color: #ff4643;
    }
  }

  :deep(.alert-container) {
    @include all-center-column;
    gap: 1rem;
    margin: 3rem 0 1rem;
    span {
      font-size: 14px;
    }
  }
}
.bg-blur {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background: #00000045;
  backdrop-filter: blur(20px);
}
</style>
